import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Toastmodal from "../Toastmodal";
import { useAuthHandling } from '../useAuthhandling';

function Subcatedit() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  let navigate = useNavigate();
  const location = useLocation();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  let { id } = useParams();
  const [toastmodal, setToastmodal] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toasttype, setToasttype] = useState("");
  const [toastlarge, setToastlarge] = useState(false);

  const [service, setService] = useState([]);
  const [formerror, setError] = useState({});
  const [oldimage, setOldimage] = useState("");
  const level=location.state.level;

  const getinfo = async (e) => {
    if (location.state.level === 1) {
      const res = await fetch(
        `${Config.apiurl}/api/v1/crm/service-category/category-detail?level=${location.state.level}`,
        {
          method: "POST",

          body: JSON.stringify({
            levelOneCategory: id,
          }),
          headers: {
            "Content-type": "application/json; charset=UTF-8",

            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        }
      );

      if (res.status === 200 ) {
        const data = await res.json();

        setService(data.data);
        setOldimage(data.data.categoryImg);
      } 
      else if(res.status === 401){
        handleUnauthorized();
        getinfo();
      }
      else {
        alert("error");

      }
    } else if (location.state.level === 2) {
      const res = await fetch(
        `${Config.apiurl}/api/v1/crm/service-category/category-detail?level=${location.state.level}`,
        {
          method: "POST",

          body: JSON.stringify({
            levelOneCategory: location.state.levelsdata.levelOneId,
            levelTwoCategory: id,
          }),
          headers: {
            "Content-type": "application/json; charset=UTF-8",

            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        }
      );

      if (res.status === 200) {
        const data = await res.json();
        setService(data.data[0].categoryInfo[0]);
        setOldimage(data.data.categoryImg);
      } 
      else if(res.status === 401){
        handleUnauthorized();
        getinfo();
      }
      else {
        alert("error");

      }
    } else if (location.state.level === 3) {
      const res = await fetch(
        `${Config.apiurl}/api/v1/crm/service-category/category-detail?level=${location.state.level}`,
        {
          method: "POST",

          body: JSON.stringify({
            levelOneCategory: location.state.levelsdata.levelOneId,
            levelTwoCategory: location.state.levelsdata.levelTwoId,
            levelThreeCategory: id,
          }),
          headers: {
            "Content-type": "application/json; charset=UTF-8",

            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        }
      );

      if (res.status === 200 ) {
        const data = await res.json();
        setService(data.data[0].categoryInfo[0]);
        setOldimage(data.data.categoryImg);
      } 
      else if(res.status === 401){
        handleUnauthorized();
        getinfo();
      }
      else {
        alert("error");

       
      }
    } else if (location.state.level === 4) {
      const res = await fetch(
        `${Config.apiurl}/api/v1/crm/service-category/category-detail?level=${location.state.level}`,
        {
          method: "POST",

          body: JSON.stringify({
            levelOneCategory: location.state.levelsdata.levelOneId,
            levelTwoCategory: location.state.levelsdata.levelTwoId,
            levelThreeCategory: location.state.levelsdata.levelThreeId,
            levelFourCategory: id,
          }),
          headers: {
            "Content-type": "application/json; charset=UTF-8",

            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        }
      );

      if (res.status === 200 ) {
        const data = await res.json();
        setService(data.data[0].categoryInfo[0]);
        setOldimage(data.data.categoryImg);
      }
      else if(res.status === 401){
        handleUnauthorized();
        getinfo();
      }
      else {
        alert("error");

        
      }
    }
  };

  let name, value;
  const handleInputs = (e) => {
    name = e.target.name;
    value = e.target.value;
    setService({ ...service, [name]: value });
  };

  const onFileChange = (e) => {
    console.log(e);
    let name = e.target.name;
    setService({ ...service, [name]: e.target.files[0] });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.categoryName) {
      errors.categoryName = "service name is required!";
    }

    if (!values.categoryDescription) {
      errors.categoryDescription = "Description is required!";
    }

    return errors;
  };

  const PostData = async (e) => {
    e.preventDefault();
    const { serviceName, description } = service;
    const ress = validate(service);
    setError(ress);
    if (!ress.serviceName && !ress.description) {
      const formData = new FormData();

      if (location.state.level === 1) {
        formData.append("categoryName", service.categoryName);
        formData.append("categoryLevel", location.state.level);
        formData.append("categoryDescription", service.categoryDescription);
        formData.append("categoryImg", service.categoryImg);
      } else if (location.state.level === 2) {
        formData.append("categoryName", service.categoryName);
        formData.append("categoryLevel", location.state.level);
        formData.append("categoryDescription", service.categoryDescription);
        if(service.categoryImg){
        formData.append("categoryImg", service.categoryImg);
        }
        formData.append(
          "levelOneCategory",
          location.state.levelsdata.levelOneId
        );
      } else if (location.state.level === 3) {
        formData.append("categoryName", service.categoryName);
        formData.append("categoryLevel", location.state.level);
        formData.append("categoryDescription", service.categoryDescription);
        if(service.categoryImg){
        formData.append("categoryImg", service.categoryImg);
        }

        formData.append(
          "levelOneCategory",
          location.state.levelsdata.levelOneId
        );
        formData.append(
          "levelTwoCategory",
          location.state.levelsdata.levelTwoId
        );
      } else if (location.state.level === 4) {
        formData.append("categoryName", service.categoryName);
        formData.append("categoryLevel", location.state.level);
        formData.append("categoryDescription", service.categoryDescription);
        if(service.categoryImg){
        formData.append("categoryImg", service.categoryImg);
        }
        formData.append(
          "levelOneCategory",
          location.state.levelsdata.levelOneId
        );
        formData.append(
          "levelTwoCategory",
          location.state.levelsdata.levelTwoId
        );
        formData.append(
          "levelThreeCategory",
          location.state.levelsdata.levelThreeId
        );
      }
      axios
        .put(
          `${Config.apiurl}/api/v1/crm/service-category/update-service-info/${id}`,
          formData,
          {
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200 ) {
            setToastmodal(true);
            setToastmessage("Sucessfully updated category");
            setToasttype("success");
            setToastlarge(false);
            setTimeout(() => navigate("/dashboard"), 3000);

            
          } 
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }
          else {
            setToastmodal(true);
            setToastmessage(res.message);
            setToasttype("error");
            setToastlarge(true);
          }
        });
    }
  };

  useEffect(() => {
    getinfo();
  }, []);
  return (
    <>
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row grid-margin">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Service Edit Table</h4>
                      <form className="forms-sample" onSubmit={PostData}>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Category Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Category Name"
                            name="categoryName"
                            value={service.categoryName}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.categoryName}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Description
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Description"
                            name="categoryDescription"
                            value={service.categoryDescription}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.categoryDescription}
                          </label>
                        </div>

                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">
                            Image (407px * 273px)
                          </label>
                          <br></br>
                          <input
                            type="file"
                            name="categoryImg"
                            onChange={onFileChange}
                          />
                          <img src={service.categoryImg} width="200" alt="" />
                        </div>
                        <button
                          type="submit"
                          onClick={PostData}
                          className="btn btn-primary me-2"
                        >
                          Submit
                        </button>
                        <ToastContainer />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}
    </>
  );
}
export default Subcatedit;
